import {AppShell} from './app-shell.js';
import * as commonUtils from '@dbp-toolkit/common/utils';

commonUtils.defineCustomElement('dbp-app-shell', AppShell);